import React from 'react';
import { Card, Accordion } from '../components';

export const CardAccordion = (props) => (
    <Card className="card-accordion">
        <Accordion {...props} />
    </Card>
);
